import {
  type FlowHumanTaskBlockConfig,
  FlowHumanTaskBlockConfigSchema,
  HumanTaskParsedConfigSchema,
  HumanTaskPayloadSchema,
  HumanTaskState,
} from 'flow-schema';
import { z } from 'zod';

export {
  type BulkTaskResult,
  BulkTaskResultSchema,
  BulkTaskStatus,
  type HumanTaskAssetPayload,
  HumanTaskAssetPayloadSchema,
  type HumanTaskAssetResponse,
  HumanTaskAssetResponseSchema,
  type HumanTaskBulkActionBody,
  HumanTaskBulkActionBodySchema,
  type HumanTaskBulkActionResponse,
  HumanTaskBulkActionResponseSchema,
  type HumanTaskPayload,
  HumanTaskPayloadSchema,
  HumanTaskState,
  type HumanTaskSubtaskStepPayload,
  HumanTaskSubtaskStepPayloadSchema,
  MAX_BULK_TASK_COUNT,
} from 'flow-schema';

export * from './submitPriorAuthorization.js';

export const HumanTaskSchema = z.object({
  id: z.uuid(),
  created: z.string().datetime(),
  updated: z.string().datetime().optional(),
  flowRunId: z.uuid(),
  blockId: z.uuid(),
  name: z.string(),
  config: FlowHumanTaskBlockConfigSchema as z.ZodType<FlowHumanTaskBlockConfig>,
  organizationId: z.uuid(),
  state: z.enum(HumanTaskState),
  assignedToId: z.uuid().nullish(),
  expiresAt: z.string().datetime(),
  payload: HumanTaskPayloadSchema.nullish(),
  parsedConfig: HumanTaskParsedConfigSchema.nullish(),
  categoryId: z.uuid().nullable(),
  externalId: z.uuid().nullish(),
  entityEhrInformationId: z.uuid().nullable(),
  entityEncounterId: z.uuid().nullable(),
  entityExternalDocumentPacketId: z.uuid().nullable(),
  entityPatientOrderId: z.uuid().nullable(),
});
export type HumanTask = z.infer<typeof HumanTaskSchema>;

export const HumanTaskSearchResultSchema = HumanTaskSchema.pick({
  // Omit payload and parsedConfig to save bandwidth / memory. This
  // intentionally uses pick instead of omit to match the select query.
  id: true,
  created: true,
  updated: true,
  flowRunId: true,
  blockId: true,
  name: true,
  config: true,
  organizationId: true,
  state: true,
  assignedToId: true,
  expiresAt: true,
  categoryId: true,
  externalId: true,
  entityEhrInformationId: true,
  entityEncounterId: true,
  entityExternalDocumentPacketId: true,
  entityPatientOrderId: true,
}).extend({
  flowId: z.uuid(),
  tags: z.array(z.string()).default([]),
});
export type HumanTaskSearchResult = z.infer<typeof HumanTaskSearchResultSchema>;

export {
  type HumanTaskClaimNextQuery,
  HumanTaskClaimNextQuerySchema,
  type HumanTaskFindAllQuery,
  HumanTaskFindAllQuerySchema,
} from 'flow-schema';
